import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import debounce from 'lodash/debounce'
import { push } from 'connected-react-router'

class IdleTimer extends React.Component {
  constructor(props) {
    super(props)
    this.eventHandler = debounce(this.updateCurrentTime.bind(this), 500)
    this.countdown = null
  }

  updateCurrentTime() {
    if (this.props.currentUser && this.props.currentUser._id) {
      localStorage.setItem('activityTime', moment().toISOString())
    }
  }

  componentDidMount() {
    this.tracker()

    localStorage.removeItem('activityTime')
    this.updateCurrentTime() // Set initial time

    if (this.props.currentUser && this.props.currentUser._id) {
      this.countdown = setInterval(this.checkTimer.bind(this), 10000)
    }
  }

  componentWillUnmount() {
    localStorage.removeItem('activityTime')
    clearInterval(this.countdown)

    // Cleanup event listeners
    window.removeEventListener('mousemove', this.eventHandler)
    window.removeEventListener('scroll', this.eventHandler)
    window.removeEventListener('keydown', this.eventHandler)
  }

  checkTimer() {
    const lastActivityTimeStr = localStorage.getItem('activityTime')
    if (!lastActivityTimeStr) return

    const lastActivityTime = moment(lastActivityTimeStr)
    const currentTime = moment()

    const minuteDiff = currentTime.diff(lastActivityTime, 'minutes')

    if (minuteDiff > 60) {
      this.logoutFxn()
    }
  }

  logoutFxn() {
    const { dispatch } = this.props
    const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null

    if (user && user._id) {
      dispatch({
        type: 'LEAVE_SOCKET',
        leaveRoom: true,
        userId: user._id
      })

      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('activityTime')
      localStorage.removeItem('chatId')
      localStorage.removeItem('dontAskOtpForIds')

      document.body.className = ''

      dispatch({ type: 'SET_CURRENT_USER', user: null })
      dispatch({ type: 'SET_CURRENT_USER_RIGHT', currentUserRights: {} })

      setTimeout(() => {
        dispatch({ type: 'LOGOUT' })
        clearInterval(this.countdown)
        if (window.location.pathname !== '/login') {
          dispatch(push('/login'))
        }
      }, 500)
    }
  }

  tracker() {
    window.addEventListener('mousemove', this.eventHandler)
    window.addEventListener('scroll', this.eventHandler)
    window.addEventListener('keydown', this.eventHandler)
  }

  render() {
    return null
  }
}

const mapStateToProps = ({ counter, global }) => ({
  count: counter.count,
  currentUser: global.currentUser
})

export default connect(mapStateToProps)(IdleTimer)
